// Custom components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

// Types
import { IMatrixColumnProps } from "./types";

export default function MatrixColumn(props: Readonly<IMatrixColumnProps>) {
	const {
		index = 0,
		item = null,
		errors = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [
						{
							type: "Duration",
							min: 0,
							max: 2208,
							decimals: 2,
							decimalsEditable: true,
							dashed: fromDisabled,
						},
					],
					value: item?.from?.value ?? 0,
					defaultType: item?.from?.input ?? "Duration",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "75px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					readOnly,
					data: [
						{
							type: "Duration",
							min: 0,
							max: 2208,
							decimals: 2,
							decimalsEditable: true,
							dashed: toDisabled,
						},
					],
					value: item?.to?.value ?? 0,
					defaultType: item?.to?.input ?? "Duration",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "75px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
				}}
			/>
		</Stack>
	);
}
